import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { ToastController } from '@ionic/angular/standalone';

/**
 * Application service.
 */
@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  /**
   * Version of the application.
   */
  public appVersion: string;

  constructor(
    private swUpdate: SwUpdate,
    private toastController: ToastController,
  ) {
    this.swUpdate.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_DETECTED') {
        this.presentToastUpdate('Downloading new version...');
      } else if (event.type === 'VERSION_READY') {
        const buttons = [
          {
            text: $localize`Cancelar`,
            role: 'cancel',
          },
          {
            text: $localize`Actualizar`,
            role: 'info',
            handler: () => {
              document.location.reload();
            },
          },
        ];
        const buttonsAux = [
          {
            text: $localize`Cancelar`,
            role: 'cancel',
            handler: () => {
              this.presentToastUpdate($localize`No actualizar a la nueva version puede causar fallos o mal funcionamiento del sistema.`, 86400000, buttons);
            }
          },
          {
            text: $localize`Actualizar`,
            role: 'info',
            handler: () => {
              document.location.reload();
            },
          },
        ];
        
        this.presentToastUpdate($localize`Nueva versión disponible`, 86400000, buttonsAux);
        // Reload the page after 2 hours if not done before
        setTimeout(() => {
          document.location.reload();
        }, 300000);
        // }, 7200000);
      } else if (event.type === 'VERSION_INSTALLATION_FAILED') {
        this.presentToastUpdate($localize`Error al instalar la nueva versión`);
        setTimeout(() => {
          document.location.reload();
        }, 300000);
        // }, 7200000);
      }
    });
  }

  async presentToastUpdate(message: string = '', duration: number = 10000, buttons = []) {
    const toast = await this.toastController.create({
      message,
      duration,
      buttons,
    });

    await toast.present();
  }
}
